import React from 'react';

import { SearchResultView } from '@bingads-webui-campaign-react/ads-studio-app-components';
import { notificationApi } from '../../adapters/get-notification';

export const SearchResultPage = props => (
  <SearchResultView {...props} notificationApi={notificationApi} />
);
